module.exports = __webpack_public_path__ + "static/media/cpg_ctv_homedecoratingchannel_video.319f9a97.png";